import { render, staticRenderFns } from "./PremiumDetailPage.vue?vue&type=template&id=0745650e&scoped=true&"
import script from "./PremiumDetailPage.vue?vue&type=script&lang=js&"
export * from "./PremiumDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./PremiumDetailPage.vue?vue&type=style&index=0&id=0745650e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745650e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VBtn,VChip,VIcon,VProgressLinear})
